/**
 * @generated SignedSource<<b459a5fabf2f5fbcebc6e34670b6d831>>
 * @relayHash 1c45745cc12810ecdbcde25f697fac8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ffe21b74af26001371a0042d20b490c10d31e8bdd61af3f5ec29791965fdf02

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceRemoveContentApprovalReviewerInput = {
  contentApprovalReviewId: string;
  principalId: string;
  principalType: ConfluencePrincipalType;
  workflowApplicationId: string;
};
export type ApprovalsContextRemoveContentApprovalReviewerMutation$variables = {
  cloudId: string;
  removeContentApprovalReviewerInput: ConfluenceRemoveContentApprovalReviewerInput;
};
export type ApprovalsContextRemoveContentApprovalReviewerMutation$data = {
  readonly confluence_removeContentApprovalReviewer: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }>;
    readonly success: boolean;
  } | null;
};
export type ApprovalsContextRemoveContentApprovalReviewerMutation = {
  response: ApprovalsContextRemoveContentApprovalReviewerMutation$data;
  variables: ApprovalsContextRemoveContentApprovalReviewerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "removeContentApprovalReviewerInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "removeContentApprovalReviewerInput",
    "variableName": "removeContentApprovalReviewerInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceContentApprovalPayload",
        "kind": "LinkedField",
        "name": "confluence_removeContentApprovalReviewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceContentApprovalPayload",
        "kind": "LinkedField",
        "name": "confluence_removeContentApprovalReviewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1c45745cc12810ecdbcde25f697fac8e",
    "id": "1ffe21b74af26001371a0042d20b490c10d31e8bdd61af3f5ec29791965fdf02",
    "metadata": {},
    "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
    "operationKind": "mutation",
    "text": "mutation ApprovalsContextRemoveContentApprovalReviewerMutation($cloudId:ID!,$removeContentApprovalReviewerInput:ConfluenceRemoveContentApprovalReviewerInput!){confluence_removeContentApprovalReviewer(cloudId:$cloudId,removeContentApprovalReviewerInput:$removeContentApprovalReviewerInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "697e5f36bdc5f862fd4fb3d7c42a7b48";

export default node;
